module.exports = {"330329100":"罗阳镇","330329101":"司前畲族镇","330329102":"百丈镇","330329103":"筱村镇","330329104":"泗溪镇","330329105":"彭溪镇","330329106":"雅阳镇","330329107":"仕阳镇","330329109":"三魁镇","330329111":"南浦溪镇","330329112":"龟湖镇","330329113":"西旸镇","330329204":"竹里畲族乡","330329225":"包垟乡","330329226":"凤垟乡","330329227":"东溪乡","330329228":"柳峰乡","330329229":"雪溪乡","330329230":"大安乡","330329400":"乌岩岭自然保护区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330329.json
// module id = 975
// module chunks = 0